import { render, staticRenderFns } from "./EstadoPersonaCombobox.vue?vue&type=template&id=43f6f97d&scoped=true"
import script from "./EstadoPersonaCombobox.vue?vue&type=script&lang=js"
export * from "./EstadoPersonaCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f6f97d",
  null
  
)

export default component.exports